export const MEETING_TOUR_ID_WITHOUT_CONNECT_CALENDAR = 'create-and-explore-meetings-without-connect-calendar';
export const MEETING_TOUR_ID_WITH_CONNECT_CALENDAR = 'create-and-explore-meetings';
export const EMPTY_STATE_FLOW_LOCAL_STORAGE_FLAG = 'meeting-empty-state-flow-active';